// extracted by mini-css-extract-plugin
export var authorAvatarContainer = "Y_c7";
export var authorInfoContainer = "Y_c8";
export var authorInfoDetails = "Y_c9";
export var authorInfoSection = "Y_db";
export var authorSocialLinks = "Y_dd";
export var authorTooltipContainer = "Y_df";
export var authorTooltipContent = "Y_c6";
export var authorTooltipLink = "Y_dc";
export var authorTooltipZIndex = "Y_dg";